import styled from 'styled-components';

import { theme } from 'components';

export const StyledContactItemContainer = styled.div`
  width: 100%;
  padding: 7px 14px;

  &:hover {
    background-color: ${theme.gray2};
    cursor: pointer;
  }
`;
